gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
var coViewportHeight = window.innerHeight;
// ==================================================================================== SECTION 1
// FLICKITY
var coCheckHtmlEditorMode = document.querySelector("html");
if (coCheckHtmlEditorMode.classList.contains("shopify-design-mode")) {
  console.log("Editor Mode");
} else {
new Flickity( '.co-home-slideshow-carousel', {
    prevNextButtons: true, 
    pageDots: false, 
    wrapAround: true,
    autoPlay: false,
    selectedAttraction: 1, 
    friction: 1,
    autoPlay: 5000,
    draggable: false
  });
new Flickity( '.co-home-slideshow-carousel-2', {
    asNavFor: ".co-home-slideshow-carousel",
    cellAlign: "center", 
    contain: true, 
    prevNextButtons: false, 
    pageDots: false, 
    wrapAround: true, 
    draggable: false,
    selectedAttraction: 1, 
    friction: 1,
    on: {
      ready: function() {

        // Entry
        gsap.set('.co-home-slideshow-media-text-ani', { opacity: 0, y: 20, transition: 0 });
        gsap.set('.co-home-slideshow-content-a-wrapper', { opacity: 0 });
        gsap.set('.co-home-slideshow-content-a-wrapper>a', { scale: 0.8 });
        // --
        gsap.set('.co-home-section-1a-wrapper', { opacity: 0, y: 30, transition: 0 });
        gsap.set('.co-home-section-1a-text-ani', { opacity: 0, y: 30, x: -10, transition: 0 });
        gsap.set('.co-home-section-1a-flower-ani', { opacity: 0, scale: 0.9, transition: 0 });
        // --
        gsap.set('.co-home-slideshow-media-frame', { opacity: 0, scale: 1.15, transformOrigin: "bottom center", transition: 0 });
        gsap.set('.co-home-slideshow-vector-1-ani', { opacity: 0, scale: 0.5, transition: 0 });
        // --
        let coHomeSec1Tl = gsap.timeline({ paused: false });
        let coHomeSec1aTl = gsap.timeline({ paused: false });
        coHomeSec1Tl.to('.co-home-slideshow-media-frame', {
          duration: 1,
          opacity: 1,
        });
        coHomeSec1Tl.to('.co-home-slideshow-media-frame', {
          duration: 1,
          ease: "power2.inOut",
          // opacity: 1,
          scale: 1
        }, "-=0.75");
        coHomeSec1Tl.to('.co-home-slideshow-vector-1-ani', {
          duration: 1,
          scale: 1,
          opacity: 1,
          ease: "power2.inOut",
          stagger: 0.05
        }, "-=0.5");
        coHomeSec1Tl.to('.co-home-slideshow-media-text-ani', {
          duration: 1,
          y: 0,
          opacity: 1,
          ease: "power1.inOut",
          stagger: 0.3
        }, "-=2");
        coHomeSec1Tl.to('.co-home-slideshow-content-a-wrapper', {
          duration: 1,
          opacity: 1,
          ease: "power1.inOut",
        }, "-=1.5");
        coHomeSec1Tl.to('.co-home-slideshow-content-a-wrapper>a', {
          duration: 2,
          scale: 1,
          opacity: 1,
          ease: "elastic.out(2, 0.3)",
        }, "-=1.5");
        // --
        coHomeSec1aTl.to('.co-home-section-1a-wrapper', {
          duration: 0.5,
          y: 0,
          opacity: 1,
          ease: "power1.inOut",
        });
        coHomeSec1aTl.to('.co-home-section-1a-text-ani', {
          duration: 1.5,
          delay: 0.75,
          y: 0,
          x: 0,
          opacity: 1,
          ease: "elastic.out(2, 0.5)",
          stagger: 0.3
        });
        coHomeSec1aTl.to('.co-home-section-1a-flower-ani', {
          duration: 1,
          scale: 1,
          opacity: 1,
          ease: "power1.inOut",
          stagger: 0.3
        }, "-=1");
        
      }
    }
  });
}
// ==================================================================================== SECTION 2
new Flickity( '.co-home-section-2-main-carousel', {
    cellAlign: "center", 
    contain: true, 
    prevNextButtons: true, 
    pageDots: false, 
    wrapAround: true, 
    selectedAttraction: 0.01, 
    friction: 0.4,
    autoPlay: 3000,
    on: {
      ready: function() {

      }
    }
  });

new Flickity( '.co-home-section-2-secondary-carousel', {
    asNavFor: ".co-home-section-2-main-carousel",
    cellAlign: "center", 
    contain: true, 
    prevNextButtons: false, 
    pageDots: false, 
    wrapAround: true, 
    draggable: false,
    selectedAttraction: 1, 
    friction: 1,
    on: {
      ready: function() {
gsap.set('.co-home-section-2-main-carousel-wrapper', { opacity: 0, scale: 1.1, transition: 0 });
gsap.set('.co-home-section-2-secondary-carousel-wrapper', { opacity: 0, scale: 1.1, transition: 0 });
gsap.set('.co-home-section-2-flower', { scale: 0, transition: 0 });
gsap.set('.co-home-section-2-grass', { scale: 0, transition: 0 });
let coHomeSec2Tl = gsap.timeline({ paused: false });
let coHomeSec2Tl2 = gsap.timeline({ paused: false });
ScrollTrigger.create({
    // markers: true,
  trigger:'.co-home-section-2', 
  start:'15% bottom', 
  end: "bottom top",
  animation: coHomeSec2Tl
});
coHomeSec2Tl.to('.co-home-section-2-secondary-carousel-wrapper', {
    duration: 1,
    scale: 1,
    opacity: 1,
    ease: "power1.inOut"
});
coHomeSec2Tl.to('.co-home-section-2-main-carousel-wrapper', {
    duration: 1,
    scale: 1,
    opacity: 1,
    ease: "power1.inOut"
}, '-=0.75');
ScrollTrigger.create({
  trigger: '.co-home-section-2-bottom', 
  start: 'top bottom', 
  end: "bottom top",
  animation: coHomeSec2Tl2
});
coHomeSec2Tl2.to('.co-home-section-2-flower', {
    duration: 1,
    scale: 1,
    ease: "power1.inOut"
});
coHomeSec2Tl2.to('.co-home-section-2-grass', {
    duration: 1,
    scale: 1,
    ease: "power1.inOut"
}, '-=0.5');
      }
    }
  });
// ==================================================================================== SECTION 3
new Flickity( '.co-home-section-3-carousel-main', {
    fade: true, 
    prevNextButtons: false, 
    pageDots: false, 
    wrapAround: true,
    autoPlay: 5000,
    on: {
      ready: function() {

      }
    }
  });
new Flickity( '.co-home-section-3-carousel-nav', {
    asNavFor: ".co-home-section-3-carousel-main", 
    contain: true, 
    cellAlign: "center", 
    pageDots: false, 
    prevNextButtons: false, 
    wrapAround: true,
    draggable: false,
    on: {
      ready: function() {
gsap.set('.co-home-section-3-frame', { opacity: 0, transition: 0 });
gsap.to('.co-home-section-3-frame', {
  scrollTrigger: {
    trigger: '.co-home-section-3', 
    start:'10% bottom', 
    end: "bottom top",
  },
  duration: 1,
  opacity: 1
});
      }
    }
  });
// ==================================================================================== SECTION 11
// MARQUEE
(function () {
let tickerSpeed = 1;
let flickity = null;
let isPaused = false;
const slideshowEl = document.querySelector('.main-carousel-marquee');
const update = () => {
  if (isPaused) return;
  if (flickity.slides) {
    flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
    flickity.selectedIndex = flickity.dragEndRestingSelect();
    flickity.updateSelectedSlide();
    flickity.settle(flickity.x);
  }
  window.requestAnimationFrame(update);
};
const pause = () => {
  isPaused = true;
};
const play = () => {
  if (isPaused) {
    isPaused = false;
    window.requestAnimationFrame(update);
  }
};
flickity = new Flickity(slideshowEl, {
  autoPlay: false,
  prevNextButtons: false,
  pageDots: false,
  draggable: true,
  wrapAround: true,
  selectedAttraction: 0.015,
  friction: 0.25
});
flickity.x = 0;
slideshowEl.addEventListener('mouseenter', pause, false);
slideshowEl.addEventListener('focusin', pause, false);
slideshowEl.addEventListener('mouseleave', play, false);
slideshowEl.addEventListener('focusout', play, false);
flickity.on('dragStart', () => {
  isPaused = true;
});
update();
})();
// ==================================================================================== GSAP
// ==================================================================================== SECTION 1
// SCRUB
gsap.set('.co-home-slideshow-vector-1>div', { xPercent: 0, transition: 0 });
gsap.to('.co-home-slideshow-vector-1>div', {
  scrollTrigger: {
    trigger: 'body',
    endTrigger: '.co-home-slideshow',
    start:'top top', 
    end: "bottom top",
    scrub: true
  },
  xPercent: -10
});
gsap.set('.co-home-slideshow-vector-2>div', { yPercent: 0, transition: 0 });
gsap.to('.co-home-slideshow-vector-2>div', {
  scrollTrigger: {
    trigger: 'body',
    endTrigger: '.co-home-slideshow',
    start:'top top', 
    end: "bottom top",
    scrub: true
  },
  yPercent: 10
});
gsap.set('.co-home-slideshow-vector-3>div', { xPercent: 0, transition: 0 });
gsap.to('.co-home-slideshow-vector-3>div', {
  scrollTrigger: {
    trigger: 'body',
    endTrigger: '.co-home-slideshow',
    start:'top top', 
    end: "bottom top",
    scrub: true
  },
  xPercent: 10
});

gsap.set('.co-home-slideshow-vector-4>div', { xPercent: 0, transition: 0 });
gsap.to('.co-home-slideshow-vector-4>div', {
  scrollTrigger: {
    trigger: 'body',
    endTrigger: '.co-home-slideshow',
    start:'top top', 
    end: "bottom top",
    scrub: true
  },
  xPercent: 10
});
gsap.set('.co-home-slideshow-vector-5>div', { yPercent: 0, transition: 0 });
gsap.to('.co-home-slideshow-vector-5>div', {
  scrollTrigger: {
    trigger: 'body',
    endTrigger: '.co-home-slideshow',
    start:'top top', 
    end: "bottom top",
    scrub: true
  },
  yPercent: -10
});
gsap.set('.co-home-slideshow-scoop-vector-keyframe', { xPercent: 0, transition: 0 });
gsap.to('.co-home-slideshow-scoop-vector-keyframe', {
  scrollTrigger: {
    trigger: 'body',
    endTrigger: '.co-home-slideshow',
    start:'top top', 
    end: "bottom top",
    scrub: true
  },
  xPercent: 20
});
gsap.set('.co-home-slideshow-media', { scale: 1, transition: 0 });
gsap.to('.co-home-slideshow-media', {
  scrollTrigger: {
    trigger: 'body',
    endTrigger: '.co-home-slideshow',
    start:'top top', 
    end: "bottom top",
    scrub: true
  },
  scale: 1.15
});
// ==================================================================================== SECTION 4
gsap.matchMedia().add("(min-width: 768px)", () => {
  ScrollTrigger.create({
    trigger: ".co-home-section-4-center",
    pin: ".co-home-section-4-left-pin",
    start: "top top",
    // end: "+=" + (coViewportHeight) * 0.5,
    end: "500px",
    // markers: true,
  });
  ScrollTrigger.create({
    trigger: ".co-home-section-4-top-title",
    pin: ".co-home-section-4-top-title",
    start: "-100px top",
    // end: "+=" + (coViewportHeight) * 0.5,
    end: "350px",
    pinSpacing: false,
    // markers: true,
  });
});
// ==================================================================================== SECTION 4A
gsap.set('.co-home-section-5-text-ani', { opacity: 0, y: 40, transition: 0 });
gsap.to('.co-home-section-5-text-ani', {
  scrollTrigger: {
    trigger: '.co-home-section-5', 
    start:'10% bottom', 
    end: "bottom top",
  },
  duration: 1,
  ease: "power1.inOut",
  y: 0,
  opacity: 1,
  stagger: 0.3
});
// SCRUB
gsap.to('.co-home-section-5-media', {
  scrollTrigger: {
    trigger: '.co-home-section-5', 
    start:'top bottom', 
    end: "bottom top",
    scrub: true
  },
  scale: 0.95
});
// ==================================================================================== SECTION 6
gsap.set('.co-home-section-6-ani', { opacity: 0, transition: 0 });
gsap.to('.co-home-section-6-ani', {
  scrollTrigger: {
    trigger: '.co-home-section-6', 
    start:'10% bottom', 
    end: "bottom top",
  },
  ease: "power1.inOut",
  duration: 1,
  opacity: 1,
  stagger: 0.3
});
// MOTIONPATH
// gsap.set(".co-plane-svg", { yPercent: -50, xPercent: -50, transformOrigin: "50% 0%", transition: "0s" });
const path = {
  immediateRender: true,
  path: "#co-plane-path-id",
  align: "#co-plane-path-id",
  autoRotate: true,
  // invalidateOnRefresh: true,
  alignOrigin: [0.5, 0],
  start: 0,
  end: 1,
};
gsap.timeline({
  defaults:{duration:1, ease:'none'}, 
  scrollTrigger:{
    trigger:'.co-home-section-6', 
    start:'top bottom', 
    end: "bottom top",
    scrub: 2
  }
}) 
  .to('.co-plane-svg', {
    motionPath: path });
ScrollTrigger.create({
    trigger:'.co-home-section-plane-frame', 
    start:'top bottom', 
    end: "bottom top",
    onUpdate: (self) => {
        self.direction === -1 ? coPlaneLeft() : coPlaneRight()
        }
});
function coPlaneRight() {
  gsap.to(".co-plane-svg-svg", {rotateY: 0, duration: 0.1});
}
function coPlaneLeft() {
  gsap.to(".co-plane-svg-svg", {rotateY: 180, duration: 0.1});
}
// ==================================================================================== SECTION 7
gsap.set('.co-home-section-7-ani', { opacity: 0, transition: 0 });
gsap.to('.co-home-section-7-ani', {
  scrollTrigger: {
    trigger: '.co-home-section-7', 
    start:'25% bottom', 
    end: "bottom top",
  },
  ease: "power1.inOut",
  duration: 1,
  opacity: 1,
  stagger: 0.3
});
// ==================================================================================== FOOTER
// gsap.set('.co-footer-frame', { opacity: 0, transition: 0 });
// gsap.to('.co-footer-frame', {
//   scrollTrigger: {
//     trigger: '.co-footer', 
//     start:'10% bottom', 
//     end: "bottom top",
//   },
//   ease: "power1.inOut",
//   duration: 1,
//   opacity: 1
// });
// ==================================================================================== SCROLLTRIGGER REFRESH
// function coScrollTriggerRefresh() {
//   ScrollTrigger.refresh();
// }
// setTimeout(coScrollTriggerRefresh, 1000);


